import { createRuntimeOperationType, extractValueFromContext, isRuntimeOperationConfig, } from './common';
export const referenceSelectorOperationType = createRuntimeOperationType({
    kind: 'REFERENCE',
    dependencies: () => [],
    run: (referenceValue, context) => {
        if (!Array.isArray(referenceValue)) {
            throw new Error(`REFERENCE value must be an array. Got ${JSON.stringify(referenceValue)}`);
        }
        if (referenceValue.some(isRuntimeOperationConfig)) {
            return {
                kind: 'REFERENCE',
                value: referenceValue,
            };
        }
        const [selector, nextSelector, ...rest] = referenceValue;
        const contextValue = context[selector];
        if (contextValue === undefined) {
            return {
                kind: 'REFERENCE',
                value: referenceValue,
            };
        }
        if (typeof contextValue === 'function') {
            return extractValueFromContext(rest, contextValue(nextSelector));
        }
        return extractValueFromContext([nextSelector, ...rest], contextValue);
    },
});
//# sourceMappingURL=reference-selector.js.map